// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import {
  assignContact,
  getSiteContactLookupInitialValues,
} from '../helpers'

const useSiteContactField = (sourceForm, lookupFormName) => {
  const dispatch = useDispatch()

  const assignSiteContact = useCallback(contact => (
    dispatch(assignContact(contact, sourceForm))
  ), [sourceForm])

  const getLookupTypeProps = useCallback(() => {
    const styles = {
      content: { width: 900 },
    }

    const {
      initialValues,
      triggerSearchOnMount,
    } = dispatch(getSiteContactLookupInitialValues(sourceForm, lookupFormName))

    return {
      initialValues,
      styles,
      triggerSearchOnMount,
    }
  }, [sourceForm, lookupFormName])

  return {
    assignSiteContact,
    getLookupTypeProps,
  }
}

export default useSiteContactField
